
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import B2BLending from "./pages/case-studies/B2BLending";
import Healthcare from "./pages/case-studies/Healthcare";
import ServiceBusiness from "./pages/case-studies/ServiceBusiness";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import CookiePolicy from "./pages/legal/CookiePolicy";
import GDPR from "./pages/legal/GDPR";
import Config from "./pages/Config";
import ColorfulV3 from "./pages/ColorfulV3";

// Create a client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ColorfulV3 />} />
            <Route path="/index" element={<Index />} />
            <Route path="/case-studies/b2b-lending" element={<B2BLending />} />
            <Route path="/case-studies/healthcare" element={<Healthcare />} />
            <Route path="/case-studies/service-business" element={<ServiceBusiness />} />

            {/* Administration */}
            <Route path="/config" element={<Config />} />
            {/* Preview: Colorful V3 */}
            <Route path="/colorful-v3" element={<ColorfulV3 />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/gdpr" element={<GDPR />} />
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
